<div class="d-flex align-items-center justify-content-center m-x-4">
  <mat-icon
    class="guide-icon"
    [matTooltip]="label | translate"
    matSuffix>
    help_outline
  </mat-icon>
</div>
